<template>
  <v-dialog
    v-model="dialog"
    :width="width"
  >
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          <span
            class="font-weight-bold"
            v-text="title"
          />
        </v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn
            icon
            @click="dialog = false"
          >
            <v-icon>{{ mdiClose }}</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text class="d-flex justify-center">
        <v-img
          :max-height="maxHeight"
          :max-width="maxWidth"
          :src="src"
        >
          <template #placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
            >
              <v-progress-circular
                indeterminate
                color="primary"
              />
            </v-row>
          </template>
        </v-img>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiClose } from '@mdi/js';

export default {
  name: 'BaseModalImage',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    src: {
      type: String,
      required: true,
      note: 'The image source',
    },
    maxHeight: {
      type: Number,
      required: true,
      note: 'The image max height',
    },
    maxWidth: {
      type: Number,
      required: true,
      note: 'The image max width',
    },
    title: {
      type: String,
      default: '',
      note: 'The modal title',
    },
  },
  data() {
    return { mdiClose };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    width() {
      return this.maxWidth + 24;
    },
  },
};
</script>
